module.exports = __webpack_public_path__ + "static/2p-edd598c6c8588ea1e7ac26af9037c3e5.jpg";